import { useNavigate } from "react-router-dom";
import { CalendarPlus, Phone } from "lucide-react";
import { CONTACT } from "../data/content";

// Sticky bottom action bar on mobile only.
export default function MobileActionBar() {
  const navigate = useNavigate();
  return (
    <div className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-slate-200 px-3 py-2.5 flex gap-2 shadow-[0_-4px_20px_rgba(15,23,42,0.08)]">
      <a
        href={CONTACT.phoneHref}
        data-testid="mobile-bar-call"
        className="flex-1 inline-flex items-center justify-center gap-2 rounded-xl border border-navy/20 text-navy font-semibold py-3 active:scale-[0.98] transition-transform"
      >
        <Phone className="w-4 h-4" /> Call
      </a>
      <button
        data-testid="mobile-bar-book"
        onClick={() => navigate("/book")}
        className="flex-[2] inline-flex items-center justify-center gap-2 rounded-xl bg-brand-orange text-white font-semibold py-3 active:scale-[0.98] transition-transform"
      >
        <CalendarPlus className="w-4 h-4" /> Book a Service
      </button>
    </div>
  );
}
